import * as React from 'react';
import { Layout } from './Layout';
import { useFillWidth } from './utils/useFillWidth';
import { jsx as _jsx } from "react/jsx-runtime";
export var ProgressBar = function ProgressBar(props) {
  var fillWidth = useFillWidth(props);
  return /*#__PURE__*/_jsx(Layout, {
    fillWidth: fillWidth
  });
};